import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind 클래스 병합 — 조건부(clsx) + 충돌 해소(tailwind-merge). shadcn·Admin Kit 원본과 동일. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
